import { render } from "./ProfesionalesDetalleCA.vue?vue&type=template&id=89dd8b02&ts=true"
import script from "./ProfesionalesDetalleCA.vue?vue&type=script&lang=ts"
export * from "./ProfesionalesDetalleCA.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/front-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__